import { createElement } from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
function Icon(props) {
    const previousClassName = props.icon.props.className ?? '';
    const className = classNames({
        [`${props.className}`]: Boolean(props.className),
        [`${previousClassName}`]: Boolean(previousClassName),
    });
    const elementProps = {
        ...props.icon.props,
        className,
        onClick: props.onClick,
        style: props.style,
    };
    return createElement(props.icon.type, elementProps);
}
export { Icon, };
//# sourceMappingURL=icon.js.map